import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async () => (await api.get("/products")).data;
export const fetchProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const fetchCustomizations = async () => (await api.get("/customizations")).data;
export const createOrder = async (payload) => (await api.post("/orders", payload)).data;
